'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Expose share user breakpoint
 * based on this breakpoint definition
 *   xxs: 0,
 *   xs: 480px,
 *   sm: 768px,
 *   md: 1024px,
 *   lg: 1280px,
 *   xl: 1440px
 */
var Breakpoint = function () {
  /**
   * Class constructor based on media queries values
   * @param {string} value assigned with css
   * @constructor
   */
  function Breakpoint(value) {
    (0, _classCallCheck3.default)(this, Breakpoint);

    this.value = value;
  }

  /**
   * get breakpoint value
   * @returns {string}
   */


  (0, _createClass3.default)(Breakpoint, [{
    key: 'getValue',
    value: function getValue() {
      /*if (this.value !== '') {
        return this.value.replace('"', '').replace('\'', '').replace(/\s/g, '').split(':')[0];
      }
      return this.value;*/
      var itsmobile = navigator.userAgent.match(/Android/i) || 
      navigator.userAgent.match(/BlackBerry/i) || 
      navigator.userAgent.match(/iPhone|iPad|iPod/i) || 
      navigator.userAgent.match(/Opera Mini/i) || 
      navigator.userAgent.match(/IEMobile/i);
      return itsmobile != null ? "mobile" : "desktop";
    }

    /**
     * get breakpoint width
     * @returns {string}
     */

  }, {
    key: 'getWidth',
    value: function getWidth() {
      if (this.value !== '' && this.value.indexOf(':') !== -1) {
        return this.value.replace(/\s/g, '').split(':')[1].replace('px', '');
      }
      return null;
    }

    /**
     * device mapping based on breakpoint value
     * @returns {string}
     */

  }, {
    key: 'getDevice',
    value: function getDevice() {
      return this.getValue();
      /*var device = '';
      var bkpt = this.getValue();
      if (bkpt !== '') {
        switch (bkpt) {
          case 'xl':
          case 'lg':
            device = 'desktop';
            break;
          case 'md':
          case 'sm':
            device = 'tablet';
            break;
          default:
            device = 'mobile';
            break;
        }
      }
      return device;*/
    }
  }]);
  return Breakpoint;
}();

exports.default = new Breakpoint('');


//////////////////
// WEBPACK FOOTER
// ./~/@univision/fe-commons/dist/utils/breakpoint/breakPointMediator.js
// module id = 96
// module chunks = 35783957827783